<template>
	<div class="d-inline-flex align-center">
		<v-btn text data-tour="catalog-download" @click="downloadDialog = true">
			<v-icon left>mdi-download</v-icon>
			Scarica catalogo
		</v-btn>
		<v-btn text data-tour="catalog-import" @click="importDialog = true">
			<v-icon left>mdi-upload</v-icon>
			Carica modifiche
		</v-btn>

		<CatalogDownloadDialog v-model="downloadDialog" :platform="platform" :fallback-marketplaces="fallbackMarketplaces" />
		<CatalogImportDialog v-model="importDialog" :platform="platform" :fallback-marketplaces="fallbackMarketplaces" @applied="$emit('applied')" />
	</div>
</template>

<script>
import CatalogDownloadDialog from './CatalogDownloadDialog';
import CatalogImportDialog from './CatalogImportDialog';

// Scarica / Carica del catalogo, condivisi fra la sezione Amazon e la sezione eBay: cambia solo la piattaforma.
export default {
	name: 'CatalogActions',
	components: { CatalogDownloadDialog, CatalogImportDialog },
	props: {
		// 'amazon' | 'ebay'
		platform: { type: String, required: true },
		fallbackMarketplaces: { type: Array, default: () => [] },
	},
	data() {
		return {
			downloadDialog: false,
			importDialog: false,
		};
	},
};
</script>
